import { ApplicationRef, NgZone } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '@environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { prepareApp } from './app/core/utils/msw.initializer';

prepareApp().then(async () => {
  try {
    const appref: ApplicationRef = await createApplication(appConfig);
    const injector = appref.injector;
    const ngZone = injector.get(NgZone);
    ngZone.run(() => {
      if (window) {
        if (!environment.console.log) {
          window.console.log = () => {};
        }
        if (!environment.console.debug) {
          window.console.debug = () => {};
        }
      }
    });
    const router = injector.get(Router);
    router.initialNavigation();
    const appElement = createCustomElement(AppComponent, { injector });
    customElements.define('app-cabinet', appElement);
  } catch (err) {
    console.error(err);
  }
});
